export default {
  BusinessPurchaseComponentsCom: {
    PO: {
      title: 'Associated Purchase Order',
      selectPurchase: 'Select Associated Purchase Order',
      noPurchase: 'No Purchase Order',
      code: 'Purchase Order No.',
      typeMeaning: 'Purchase Type',
      statusMeaning: 'Status',
      stockinStatusMeaning: 'Inbound Status',
      supplierName: 'Supplier',
      warehouseName: 'Receiving Warehouse',
      planQty: 'Purchase Quantity',
      amount: 'Purchase Total Amount',
      alreadyQty: 'Inbound Quantity',
      cancelQty: 'Stop waiting quantity',
      buyerName: 'Purchaser',
      loosDate: 'Departure Time'
    },

    baseMsg: {
      title: 'Account Information',
      oddNumber: 'Order No.',
      automatic: 'Auto Generate',
      type: 'Type',
      warehouse: ' Warehouse',
      supplier: 'Supplier',
      logisticsBusiness: 'Logistics Company',
      logisticsNo: 'Logistics Number',
      recipientName: 'Recipient',
      recipientPhone: 'Consignee mobile phone',
      recipientAddress: 'Receiving Address',
      detailAddress: 'Detailed Address',
    },

    commodityMsg: {
      title: 'Product Information',
      add: 'Add ',
      commodity: ' Commodity',
      spuPic: 'Product Image',
      spuCode: 'Product Code',
      spuName: 'Product Name',
      skuCode: 'SKU',
      skuName: 'SKU Name',
      planQtyLabel1: 'Documents',
      planQtyLabel2: 'Return',
      planQtyLabel3: 'Quantity',
      planQty: 'Document Quantity',
      taxUnitPrice: 'The unit price including tax',
      noTaxUnitPrice: 'Purchase Price Excluding Tax',
      taxRate: 'Tax Rate',
      taxPrice: 'Price Including Tax Amount',
      supplierSpuCode: 'Supplier Product Code',
      supplierSkuCode: 'Supplier SKU Code',
    },

    rules: {
      type: 'Please select inbound type',
      warehouseCode: 'Please select a receiving warehouse',
      supplierCode: 'Please select a supplier',
      logisticsBusinessId: 'Please select logistics company',
      planQty: 'Please enter document quantity',
      taxUnitPrice: 'Please enter the unit price including tax',
      taxRate: 'Please enter tax rate'
    },

    bjDialogText: 'Please select associated purchase order',
    purchaseCode: 'Associated Purchase Order No.',
    choosePurchase: 'Select Purchase',
    commodity: 'commodity',
    spuCode: 'Product Code',
    spuName: 'Product Name',
    skuCode: 'SKU',
    skuName: 'SKU Name',
    planQty: 'Purchase Quantity',
    waitQty: 'Unreceived Quantity',
    taxUnitPrice: 'Including Tax Price',
    taxRate: 'Tax Rate',
    supplierSpuCode: 'Supplier commodity code',
    msgError: 'Please select inbound product',
    storage: 'Inbound',
    returnGoods: 'Return',
    outWarehouse: 'Outbound',
    msgError1: 'The selected supplier is inconsistent, please choose again!',
    msgError2: 'There is no product in this purchase order, please choose another purchase order!',
    invoiceNo: 'Invoice No.',
    onPackUpBtn: 'Collapse Empty Fields',
    onSpreadBtn: 'Expand Empty Fields',
    alreadyQty: 'Purchased Inventory Quantity',
    allPlanQty: 'Total Purchase Quantit',
    RecoveryStatus:'Recovery Status',
    Recovered:'Recovered',
    NotRecovered:'Not Recovered',
    Profit:'Profit Margin (%)',
    amount:'Recovered Amount (AUD)',
  }
};
